import { render, staticRenderFns } from "./DxfInput.vue?vue&type=template&id=908bc664"
import script from "./DxfInput.vue?vue&type=script&lang=js"
export * from "./DxfInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports